/* eslint-disable no-restricted-syntax */
import store from '@/store'
import { isPagesPersonalizationEnabled } from '@/auth'
import formioFullCss from '!!raw-loader!@formio/js/dist/formio.full.min.css'
import novtiFormioComponentsCss from '!!raw-loader!@novtilab/novti-formio-components/styles.css'
import personalizationCss from '../components/personalization/canvas-styles'

export default function canvas() {
  // Bundled Formio CSS (same file/version as Form Preview) plus Novti
  // component styles. Injected as canvasCss so they never become stored
  // page CSS — GrapesJS only persists the component/style model.
  const canvasCss = [
    formioFullCss,
    novtiFormioComponentsCss,
    isPagesPersonalizationEnabled() ? personalizationCss : '',
  ].join('\n')
  const scripts = []
  const styles = []

  // Get the active Theme
  const activeTheme = store.getters['themes/getActiveTheme']
  const activeThemeStyles = store.getters['themes/getActiveExternalResources']('css')
  const activeThemeScripts = store.getters['themes/getActiveExternalResources']('js')

  if (activeTheme) {
    for (const script of activeThemeScripts) {
      scripts.push(script.src)
    }

    for (const style of activeThemeStyles) {
      styles.push(style.src)
    }

    styles.push(`${process.env.VUE_APP_CDN_URL}/${activeTheme.data.storage}/public/styles.bundle.css`)
    scripts.push(`${process.env.VUE_APP_CDN_URL}/${activeTheme.data.storage}/public/app.bundle.js`)
  }

  return {
    canvas: {
      styles,
      scripts,
    },
    canvasCss,
  }
}
